import React from 'react';
import { Pencil, UserRound } from 'lucide-react';

export const COMPRADOR_VACIO = { nombre: '', telefono: '', correo: '', tipo_documento: 'CC', numero_documento: '', sitio_web: '' };

const TIPOS = [['CC', 'Cédula de ciudadanía'], ['CE', 'Cédula de extranjería'], ['NIT', 'NIT'], ['PAS', 'Pasaporte'], ['TI', 'Tarjeta de identidad']];
const claseCampo = 'w-full rounded-xl border border-[#27272A] bg-[#0A0A0A] px-4 py-3 text-sm text-white placeholder-zinc-600 outline-none transition-colors focus:border-[#C9A962]';

const Campo = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs font-medium uppercase tracking-wider text-zinc-500">{label}</span>
    {children}
  </label>
);

export default function PasoDatosInvitado({ comprador, setComprador }) {
  const cambiar = (k) => (e) => setComprador(c => ({ ...c, [k]: e.target.value }));
  return (
    <div className="space-y-4" data-testid="paso-datos">
      <div>
        <h3 className="text-lg font-medium text-white">Tus datos</h3>
        <p className="text-sm text-zinc-400">Los usamos para tu factura y para contactarte sobre tu pedido.</p>
      </div>
      <div className="space-y-4 rounded-2xl border border-[#27272A] bg-[#18181B] p-5">
        <Campo label="Nombre completo">
          <input value={comprador.nombre} onChange={cambiar('nombre')} maxLength={100} autoComplete="name" className={claseCampo} data-testid="comprador-nombre" />
        </Campo>
        <div className="grid gap-4 sm:grid-cols-2">
          <Campo label="Celular / WhatsApp">
            <input type="tel" inputMode="tel" value={comprador.telefono} onChange={cambiar('telefono')} maxLength={25} autoComplete="tel" placeholder="+57 300 000 0000" className={claseCampo} data-testid="comprador-telefono" />
          </Campo>
          <Campo label="Correo electrónico">
            <input type="email" value={comprador.correo} onChange={cambiar('correo')} maxLength={120} autoComplete="email" placeholder="correo@ejemplo.com" className={claseCampo} data-testid="comprador-correo" />
          </Campo>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <Campo label="Tipo de documento">
            <select value={comprador.tipo_documento} onChange={cambiar('tipo_documento')} className={claseCampo} data-testid="comprador-tipo-documento">
              {TIPOS.map(([id, nombre]) => <option key={id} value={id}>{nombre}</option>)}
            </select>
          </Campo>
          <Campo label="Número de documento">
            <input value={comprador.numero_documento} onChange={cambiar('numero_documento')} maxLength={20} className={claseCampo} data-testid="comprador-documento" />
          </Campo>
        </div>
        <input value={comprador.sitio_web} onChange={cambiar('sitio_web')} name="sitio_web" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" />
      </div>
      <p className="text-xs text-zinc-500" data-testid="datos-sugerir-login">
        ¿Ya tienes cuenta Mi JPM? <a href="/mi-jpm" className="text-[#C9A962] hover:underline">Inicia sesión</a> para usar tus Puntos JPM en esta compra.
      </p>
    </div>
  );
}

export const ResumenComprador = ({ comprador, onEditar }) => (
  <div className="flex items-start gap-3 rounded-2xl border border-[#27272A] bg-[#18181B] p-4" data-testid="resumen-comprador">
    <UserRound className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A962]" />
    <div className="min-w-0 flex-1 text-sm">
      <p className="font-medium text-white">{comprador.nombre}</p>
      <p className="truncate text-zinc-400">{comprador.telefono} · {comprador.correo}</p>
      <p className="text-xs text-zinc-500">{comprador.tipo_documento} {comprador.numero_documento}</p>
    </div>
    <button type="button" onClick={onEditar} className="flex items-center gap-1 rounded-lg px-2 py-1.5 text-xs text-[#C9A962] hover:bg-[#C9A962]/10" data-testid="resumen-comprador-editar">
      <Pencil className="h-3.5 w-3.5" />Cambiar
    </button>
  </div>
);
